import type { LogEvent } from "~/utils/logging/LogEvent";
import type { LoggingSink } from "~/utils/logging/LoggingSink";

interface AsyncLoggingSink extends LoggingSink {
    cancelAnyPendingLogEvents(): void;
}

export function createAsyncLoggingSink(loggingSink: LoggingSink): AsyncLoggingSink {
    let timeouts: ReturnType<typeof setTimeout>[] = [];

    return {
        receiveLogEvent(logEvent: LogEvent) {
            const timeout = setTimeout(() => {
                loggingSink.receiveLogEvent(logEvent);
                timeouts = timeouts.filter((t) => t !== timeout);
            });
            timeouts = [...timeouts, timeout];
        },
        cancelAnyPendingLogEvents() {
            timeouts.forEach(clearTimeout);
        },
    };
}
